export default {
  billOfLadingNumber: 'شماره بارنامه',
  transportCompanyID: 'شناسه شرکت حمل',
  transportCompanyName: 'نام شرکت حمل',
  payableAmount: 'مبلغ قابل پرداخت',
  payableAmountRial: 'مبلغ قابل پرداخت(ریال)',
  freightCost: 'مبلغ کرایه',
  insuranceAmount: 'مبلغ بیمه',
  trackingReceiptTime: 'ساعت در یافت رهگیری',
  year: 'سال',
  month: 'ماه',
  serialNumber: 'سریال بارنامه',
  companyId: 'کد پروژه',
  companyName: 'شرکت حمل',
  trackingCode: 'کد رهگیری',
  weightKilogram: 'وزن(کیلوگرم)',
  fare: 'کرایه',
  distance: 'مسافت',
  originCityCode: 'کد مبدأ',
  originCityName: 'نام مبدأ',
  destinationCityCode: 'کد مقصد',
  destinationCityName: 'نام مقصد',
  cargoId: 'شناسه کالا',
  cargoName: 'نام کالا',
  issueDate: 'تاریخ صدور',
  vehiclePlateNumber: 'پلاک',
  vehicleSerial: 'سریال ماشین',
  vehicleNumberingPlaceCode: 'کد محل شماره‌گذاری',
  vehicleNumberingPlaceName: 'نام محل شماره‌گذاری',
  loadingCode: 'کد نوع بارگیر',
  loadingType: 'نوع بارگیر',
  packingCode: 'کد نوع بسته‌بندی',
  packingType: 'نوع بسته‌بندی',
  insuranceCode: 'کد بیمه (شعبه)',
  insuranceNumber: 'شماره بیمه‌نامه',
  driverNationalId: 'کد ملی راننده اول',
  driverName: 'راننده اول',
  driverSmartCardCode: 'شماره کارت هوشمند راننده اول',
  driverDocumentId: 'شماره پرونده راننده اول',
  secondDriverNationalId: 'کد ملی راننده دوم',
  secondDriverName: 'نام راننده دوم',
  secondDriverSmartCardCode: 'شماره کارت هوشمند راننده دوم',
  secondDriverDocumentId: 'شماره پرونده راننده دوم',
  vehicleSmartCardCode: 'شماره کارت هوشمند ناوگان',
  vehicleDocumentNumber: 'شماره پرونده ناوگان',
  senderName: 'نام فرستنده',
  senderNationalCode: 'شناسه ملی فرستنده',
  senderPostCode: 'کدپستی فرستنده',
  senderAddress: 'آدرس فرستنده',
  receiverName: 'نام گیرنده',
  receiverNationalCode: 'شناسه ملی گیرنده',
  receiverPostCode: 'کدپستی گیرنده',
  receiverAddress: 'آدرس گیرنده',
  registrationTime: 'ساعت ثبت',
  trackingTime: 'ساعت دریافت کد رهگیری',
  totalCostRial: 'هزینه کل(ریال)',
  companyCommission: 'درصد کمیسیون شرکت',
  insuranceCost: 'هزینه بیمه',
  insuranceCompany: 'کد شرکت بیمه',
  description: 'توضیحات',
  cargoDescription: 'توضیحات کالا',
  cargoValueRial: 'ارزش کالا(ریال)',
  trackingDate: 'تاریخ دریافت کد رهگیری',
  isCancelled: 'باطل شده',
  moveToProcessingStage: 'انتقال به مرحله پردازش',
  billOfLadingSuccessfullyTransferred: 'بارنامه(ها) با موفقیت انتقال یافتند',
  billOfLadingStatus: 'بارنامه های {status}',
  paymentQueue: 'در صف پرداخت',
  issueDateFrom: 'تاریخ صدور از',
  issueDateTo: 'تاریخ صدور تا',
  renterRegistration: 'ثبت گیرنده کرایه',
  inquiry: 'استعلام',
  renterName: 'گیرنده کرایه',
  renterShebaNumber: 'شماره شبا گیرنده کرایه',
  renterMobile: 'شماره موبایل گیرنده کرایه',
  renterNationalId: 'کدملی گیرنده کرایه',
  shebaNumberAndNationalIdIsMatched: 'شماره شبا و کد ملی مطابقت دارد',
  revertToReceivedStage: 'بازگرداندن به مرحله دریافت',
  billOfLadingId: 'شناسه بارنامه',
  payDate: 'تاریخ پرداخت',
  payDateFrom: 'تاریخ پرداخت از',
  payDateTo: 'تاریخ پرداخت تا',
  referenceNumber: 'شماره ارجاع'
}
